import { render, staticRenderFns } from "./r-card-panel.vue?vue&type=template&id=ccb65154"
import script from "./r-card-panel.vue?vue&type=script&lang=js"
export * from "./r-card-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccb65154')) {
      api.createRecord('ccb65154', component.options)
    } else {
      api.reload('ccb65154', component.options)
    }
    module.hot.accept("./r-card-panel.vue?vue&type=template&id=ccb65154", function () {
      api.rerender('ccb65154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/card/r-card-panel.vue"
export default component.exports